import { z } from 'zod/v4';

export const WeekValues = ['월', '화', '수', '목', '금', '토', '일'] as const;
export const WeekSchema = z.enum(WeekValues);
export type WeekType = z.infer<typeof WeekSchema>;

// ex: { week: "월", start: "09:00", end: "11:00", classroom: "정보과학관 101" }
export const CourseTimeResponseSchema = z.object({
  week: WeekSchema,
  start: z.string(), // HH:MM 형식 (ex: 09:00)
  end: z.string(), // HH:MM 형식 (ex: 11:00)
  classroom: z
    .string()
    .nullable()
    .transform((classroom) => classroom ?? ''),
});
export type CourseTimeResponseType = z.infer<typeof CourseTimeResponseSchema>;

export const TimetableCourseSchema = z.object({
  id: z.number().nullable().optional(),
  category: z.string(),
  subCategory: z.string().nullable().optional(),
  field: z.string().nullable().optional(),
  code: z.number(),
  name: z.string(),
  professor: z.string().nullable().optional(),
  department: z.string(),
  division: z.string().nullable().optional(),
  time: z.string(),
  point: z.string(),
  personeel: z.number(),
  scheduleRoom: z.string(),
  target: z.string(),
  courseTimes: z.array(CourseTimeResponseSchema),
});
export type TimetableCourseType = z.infer<typeof TimetableCourseSchema>;

export const TimetableTrackSchema = z.object({
  trackName: z.string(),
  courses: z.array(TimetableCourseSchema),
});
export type TimetableTrackType = z.infer<typeof TimetableTrackSchema>;

export const TimetableSchema = z.object({
  timetableId: z.number(),
  tag: z.string(),
  score: z.number().nullable().optional(),
  totalPoint: z.number(),
  courses: z.array(TimetableCourseSchema),
});
export type TimetableType = z.infer<typeof TimetableSchema>;
export type TimetableInputType = z.input<typeof TimetableSchema>;
